export const categoryColors: Record<string, string> = {
  "rental_service": "#169dea",
  "accommodation": "#3ca227",
  "restaurant": "#ea1616",
  "event": "#ffde59",
  "attraction": "#ff5757",
  "shop": "#cb6ce6",
  "transportation": "#ff6e15",
  "experience": "#7ed957",
  "venue": "#4a76b2",
};

export const markerIcons = {
  rental_service: 'service_markers/rental_service.png',
  accommodation: 'service_markers/accommodation.png',
  restaurant: 'service_markers/restaurant.png',
  event: 'service_markers/event.png',
  attraction: 'service_markers/attraction.png',
  shop: 'service_markers/shop.png',
  transportation: 'service_markers/transportation.png',
  experience: 'service_markers/experience.png',
  venue: 'service_markers/venue.png',
};